package com.appcreator.compose.components

import androidx.compose.foundation.layout.Box
import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.ui.Modifier
import com.appcreator.blueprint.components.ReferenceComponent
import com.appcreator.compose.loaders.ComponentFetcher

@Composable
actual fun ReferenceComposable(componentFetcher: ComponentFetcher, modifier: Modifier, component: ReferenceComponent) {
    val wrapper = LocalComponentModifierProvider.current
    wrapper.Wrap(modifier, component, content = {
        Box(it) {
            CompositionLocalProvider(LocalComponentModifierProvider provides ComponentContentWrapper { modifier, _, content ->
                content(modifier)
            }) {
                ReferenceComposableInternal(componentFetcher, modifier, component)
            }
        }
    })
}
